import {block, unblock} from './block-ui';
import {alert, prompt} from './alerts';
import mix from '../helpers/mix';
import {addedToCart} from "../components/GoogleAnalytics/UserAction";

mix.loadCSS(appConfig.isDesktop ? 'css/desktop/one-click-form.css' : 'css/mobile/one-click-form.css');

export default function (ev) {
    ev.preventDefault();

    var id = $(this).parents('.js-good').data('id');
    var nameov = $(this).data('nameov');
    var namea = $(this).data('namea');
    var name = $(this).data('name');

    var oneClickBuyForm = function () {
        $('#one-click-buy-form').remove();
        const phoneFromParentForm = $('.track-good-head .phone-value input').val() ?? '';
        var div = document.createElement('div');
        div.setAttribute('id', 'one-click-buy-form');
        div.setAttribute('class', 'alerts');

        let phoneBlock = !USER_ID
            ? `<div class="one-click_phone">
                    <p class="one-click_label">${trans('good.one_click.enter_phone_number')}</p>
                    <div class="one-click_field">
                        <span class="phone-code">${MOBILE_COD}</span>
                        <div class="phone-value">
                            <input type="text" class="js-phone-number" autocomplete="off" value="${ONE_CLICK_PHONE ? ONE_CLICK_PHONE : phoneFromParentForm}">
                        </div>
                    </div>
                </div>`
            : '';

        $.get(
            `/good/${id}/opt-prices/`,
            response => {
                let prices = '';

                if (response.status === 'success') {
                    prices = `<div style="font-size: 16px; margin-top: 10px;color: white; font-weight: bold;clear: both;">${trans(
                        'common.price_upper'
                    )} ${response.price}</div>`;
                    prices += response.opt
                        .map(row => {
                            return `<div style="font-size: 12px; margin-bottom: -10px; margin-top: 10px;">${row}</div>`;
                        })
                        .join('');

                    prices += '<br>';
                }

                // Auto-check for operators
                const checkboxOperator =
                    typeof window.appConfig !== 'undefined' && window.appConfig.isOperator ? 'checked' : '';

                div.innerHTML = `
                    <div id="one-click" class="opened">
                        <div id="overlay">&nbsp;</div>
                        <div class="one-click_wrap" style="width: 345px">
                            <div class="one-click_popup">
                                <a rel="nofollow" href="javascript:void(0)" class="crossClose" onclick="$('#one-click-buy-form').remove(); alerted=0;">+</a>
                                <div class="one-click_title">${trans('good.one_click.buy')}</div>

                                ${prices}

                                <div class="one-click_form" align="left">
                                    ${phoneBlock}

                                    <div class="one-click_amount">
                                        <p class="one-click_label">${trans('good.one_click.quantity')}</p>
                                        <div class="one-click_quantity">
                                            <div class="quantity-down">–</div>
                                            <div class="quantity-field">
                                                <input type="text" class="js-quantity" min="1" max="999" maxlength="3" step="1" value="1">
                                            </div>
                                            <div class="quantity-up">+</div>
                                        </div>
                                    </div>

                                    <div style="margin-bottom:1rem;color:#fff">
                                        <label>
                                            <input type="checkbox" class="js-one-click-agreement" ${checkboxOperator}>

                                            ${trans('good.one_click.i_agree')}
                                        </label>
                                    </div>

                                    <div class="one-click_action">
                                        <a rel="nofollow" href="javascript:void(0)" class="close" onclick="oneClickConfirm(${id}, '${name}', '${namea}', USER_MOBILE)">${trans(
                        'good.one_click.order'
                    )}</a>
                                        <a rel="nofollow" href="javascript:void(0)" onclick="$('#one-click-buy-form').remove(); alerted=0;">${trans(
                                            'good.one_click.close'
                                        )}</a>
                                    </div>
                                </div>
                           </div>

                        </div>
                    </div>
                `;

                $(div).on('click', '.quantity-down', function (e) {
                    e.preventDefault();
                    var input = $(this).parents('.one-click_quantity').find('.js-quantity');

                    if (input.val() > 1) {
                        $(this)
                            .parents('.one-click_quantity')
                            .find('.js-quantity')
                            .val((i, oldval) => {
                                return --oldval;
                            });
                    }
                });

                $(div).on('click', '.quantity-up', function (e) {
                    e.preventDefault();

                    $(this)
                        .parents('.one-click_quantity')
                        .find('.js-quantity')
                        .val((i, oldval) => {
                            var newVal = parseInt(oldval) + 1;

                            if (newVal > 999) {
                                newVal = 999;
                            }

                            return newVal;
                        });
                });
            },
            'json'
        );

        $('#one-click-buy-form').show();

        return document.body.appendChild(div);
    };

    return oneClickBuyForm();
}

$('.js-one-click-buy').click(function (ev) {
    ev.preventDefault();

    if (typeof fbq !== 'undefined' && fbq) {
        fbq('track', 'Lead');
    }

    if (typeof window.ga !== 'undefined' && window.ga) {
        ga('send', 'event', 'Кнопка1кликТовар', 'ЗаказатьВ1Клик');
    }

    var id = $(this).parents('.js-good').data('id');
    var phone = $('.js-one-click-buy-phone').val();
    phone = phone.replace(/\D/g, '');

    var name = $(this).data('name');
    var nameov = $(this).data('nameov');
    var namea = $(this).data('namea');

    if (phone.length !== PHONE_LENGTH) {
        // Произошла ошибка
        alert(
            trans('user.phone_length', {
                length: PHONE_LENGTH,
            }),
            trans('user.phone_length_caption')
        );
        return;
    }

    $.get(
        `/good/${id}/opt-prices/`,
        response => {
            let prices = '';

            if (response.status === 'success') {
                prices = `<div style="font-size: 16px; margin-top: 10px;color: black;">ЦЕНА ${response.price}</div>`;
                prices += response.opt
                    .map(row => {
                        return `<div style="font-size: 12px; margin-bottom: -10px; margin-top: 10px;">${row}</div>`;
                    })
                    .join('');

                prices += '<br>';
            }

            prompt(prices + trans('cart.how_much_full', {name: nameov}), 1, value => {
                let quantity = Math.round(value);

                if (null === value) {
                    return;
                } else if (quantity < 1) {
                    // Добавить можно не менее 1
                    return alert(trans('cart.cann_add_less_1_full', {name: namea}), trans('cart.error'));
                }

                oneClickMakeOrder(id, name, phone, quantity);
            });
        },
        'json'
    );
});

function oneClickMakeOrder(id, name, phone, quantity) {
    block();

    $.post(
        '/good/one-click-buy/',
        {id, phone, quantity},
        function (response) {
            tracker.track('Покупка в 1 клик', {
                id: id,
                'Номер телефона': phone,
            });

            unblock();
            $('#one-click-buy-form').remove();

            if (!response) {
                return;
            }

            var message = trans('good.one_click_order_created');

            if (response.existingOrderName) {
                // Good added to existing order
                message +=
                    ' ' +
                    trans('good.one_click_existing_order_used', {
                        order: response.existingOrderName,
                    });
            }

            if (typeof ONE_CLICK_WORKTIME !== 'undefined' && ONE_CLICK_WORKTIME !== trans('common.work_time')) {
                // Non-working time
                message += ' ' + ONE_CLICK_WORKTIME;
            } else {
                message += ' ' + trans('good.one_click_order_manager_call');
            }

            // Google Analytics E-Commerce
            $('body').append(`<script src="/ecommerce/one-click-order/${response.id}/" style="width: 0;height: 0;"></script>`);
            // addedToCart(id, name, quantity, response.price);

            alert(message, trans('good.one_click_order_created_caption'));
        },
        'json'
    );
}

window.oneClickConfirm = (id, name, namea, mobile = '') => {
    var form = $('#one-click-buy-form'),
        phone_number = form.find('.js-phone-number').val(),
        quantity = form.find('.js-quantity').val();

    if (!form.find('.js-one-click-agreement').is(':checked')) {
        alert(trans('good.one_click.accept_agreement'));
        return;
    }

    if (mobile.length) {
        phone_number = mobile;
    } else if (
        (!mobile.length && (phone_number.length !== PHONE_LENGTH || /\D/i.test(phone_number))) ||
        (phone_number && phone_number[0] !== '0')
    ) {
        // Произошла ошибка
        alert(
            trans('good.one_click_order_phone', {
                length: PHONE_LENGTH,
            }),
            trans('user.phone_length_caption')
        );
        return;
    }

    if (!quantity.length) {
        // Поле количество не может быть пустым
        return alert(trans('good.one_click_no_quantity'));
    } else if (quantity < 1) {
        // Добавить можно не менее 1
        return alert(trans('cart.cann_add_less_1_full', {name: namea}), trans('cart.error'));
    } else if (false === /^[0-9]+$/.test(quantity)) {
        // Поле количество должно быть числом
        return alert(trans('good.one_click_is_not_int'));
    }

    oneClickMakeOrder(id, name, phone_number, quantity);
};
